(() => {
  'use strict';
  const article = document.querySelector('[data-kk-blog-article]');
  if (!article || window.__kkBlogAnalytics) return;
  window.__kkBlogAnalytics = true;
  const sent = new Set();
  let activeSeconds = 0;
  let lastTick = performance.now();
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.currentVisitorConsent?.().analytics === 'yes'
      && privacy?.analyticsProcessingAllowed?.() === true;
  };
  const visible = () => {
    const rect = article.getBoundingClientRect();
    return !document.hidden && rect.top < window.innerHeight && rect.bottom > 0;
  };
  const emit = (name, data = {}, once = true) => {
    const publish = window.Shopify?.analytics?.publish;
    const key = name + ':' + (data.percent || '');
    if (!allowed() || typeof publish !== 'function' || (once && sent.has(key))) return;
    try {
      publish('koerperkult:' + name, {
        article_id: article.dataset.kkBlogArticle,
        article_path: window.location.pathname,
        ...data
      });
      if (once) sent.add(key);
    } catch (_) { /* A pixel must never interrupt the storefront. */ }
  };
  const sample = () => {
    const now = performance.now();
    const elapsed = Math.min((now - lastTick) / 1000, 1.5);
    lastTick = now;
    if (!allowed() || !visible()) return;
    emit('blog_view');
    activeSeconds += elapsed;
    const rect = article.getBoundingClientRect();
    const progress = Math.max(0, Math.min(100, (window.innerHeight - rect.top) / rect.height * 100));
    // Scroll depth plus visible time is a reading signal, not proof of reading.
    if (activeSeconds >= 10) {
      for (const percent of [25, 50, 75, 90]) {
        if (progress >= percent) emit('blog_progress', { percent });
      }
    }
    if (activeSeconds >= 30 && progress >= 50) emit('blog_engaged');
  };
  article.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || !article.contains(link) || !allowed()) return;
    const target = new URL(link.href, window.location.origin);
    if (target.origin !== window.location.origin) return;
    if (/^\/products\/[^/]+\/?$/.test(target.pathname)) {
      emit('blog_product_click', { target_path: target.pathname }, false);
    } else if (/^\/collections\//.test(target.pathname) || target.pathname === '/pages/pflegeroutinen') {
      emit('blog_selection_click', { target_path: target.pathname }, false);
    }
  });
  document.addEventListener('visitorConsentCollected', () => {
    lastTick = performance.now();
    if (!allowed()) activeSeconds = 0;
    if (allowed() && visible()) emit('blog_view');
  });
  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
      if (allowed() && visible()) emit('blog_view');
    });
  }
  window.setInterval(sample, 1000);
})();
